/**
 * Chalk & Court — design tokens for the SGA staff app.
 *
 * A light, athletic aesthetic: warm chalk-paper backgrounds, a single bold
 * coral accent reserved for the live shift + primary actions, and a deep
 * court green for completed work. Heavy condensed display type (Barlow
 * Condensed) for headings and times; Barlow for body copy.
 */

export const colors = {
  // Surfaces
  bg: '#F1ECDF', // warm chalk paper
  surface: '#FFFFFF',
  surfaceSunk: '#FBF8F0', // recessed cards (completed shifts)

  // Ink
  ink: '#1C1A12', // primary text — warm near-black
  inkSoft: '#5C574A', // secondary text
  inkFaint: '#9C9582', // tertiary / upcoming

  // Chalk lines & borders
  line: '#E2DAC5',
  lineStrong: '#CFC5A8',

  // Accent — bold coral, the "live" + action color
  accent: '#EB4A26',
  accentDark: '#C53A1B',
  accentSoft: '#FBE3DB',
  onAccent: '#FFFFFF',

  // Court green — completed work
  court: '#1F5E3C',
  courtSoft: '#E0EBE0',

  // Amber — warnings (unclosed punch)
  warn: '#A8730C',
  warnSoft: '#F6EBCF',
} as const;

export const font = {
  display: 'BarlowCondensed_800ExtraBold',
  displayBold: 'BarlowCondensed_700Bold',
  displayMed: 'BarlowCondensed_600SemiBold',
  body: 'Barlow_400Regular',
  bodyMed: 'Barlow_500Medium',
  bodySemi: 'Barlow_600SemiBold',
  bodyBold: 'Barlow_700Bold',
} as const;

export const space = {
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
  xxl: 32,
} as const;

export const radius = {
  sm: 8,
  md: 14,
  lg: 20,
  pill: 999,
} as const;

/** Soft, warm-tinted elevation for raised cards. */
export const shadow = {
  card: {
    shadowColor: '#3A3320',
    shadowOffset: { width: 0, height: 6 },
    shadowOpacity: 0.1,
    shadowRadius: 14,
    elevation: 3,
  },
  live: {
    shadowColor: '#EB4A26',
    shadowOffset: { width: 0, height: 8 },
    shadowOpacity: 0.22,
    shadowRadius: 18,
    elevation: 6,
  },
} as const;
